import api from './index';

const url = 'client';
export default {
  async create(data) {
    return api.post(`${url}`, data);
  },
};
